"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectArrayRenderer = exports.ObjectArrayControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@jsonforms/core");
const react_1 = require("@jsonforms/react");
const antd_1 = require("antd");
const lodash_range_1 = __importDefault(require("lodash.range"));
const react_2 = require("react");
const usePreviousValue_1 = require("../common/usePreviousValue");
const react_3 = __importDefault(require("react"));
function ObjectArrayControl({ data, enabled, path, schema, uischema, addItem, removeItems, renderers, cells, visible, rootSchema, uischemas, required, }) {
    const foundUISchema = (0, react_2.useMemo)(() => {
        return (0, core_1.findUISchema)(uischemas ?? [], schema, uischema.scope, path, undefined, uischema, rootSchema);
    }, [uischemas, schema, path, uischema, rootSchema]);
    const dataSource = (0, react_2.useMemo)(() => (0, lodash_range_1.default)(data), [data]);
    const addItemToList = (0, react_2.useMemo)(() => addItem(path, (0, core_1.createDefaultValue)(schema, rootSchema)), [addItem, path, rootSchema, schema]);
    const prevDataValue = (0, usePreviousValue_1.usePreviousValue)(data);
    (0, react_2.useEffect)(() => {
        if (data === 0 && prevDataValue === null) {
            addItemToList();
        }
    });
    const formItemProps = "formItemProps" in uischema ? uischema.formItemProps : {};
    const labelDescription = core_1.Helpers.createLabelDescriptionFrom(uischema, schema);
    const label = labelDescription.show ? labelDescription.text : "";
    const options = uischema.options ?? {};
    const addButton = ((0, jsx_runtime_1.jsx)(antd_1.Flex, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Button, { ...options.addButtonProps, onClick: (e) => {
                e.stopPropagation();
                addItemToList();
            }, children: options.addButtonProps?.children ?? `Add ${label}` }) }));
    if (!visible) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(antd_1.Form.Item, { required: required, rules: [{ required: required, message: `${label} is required` }], validateTrigger: ["onBlur"], ...formItemProps, children: [(0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: label }), (0, jsx_runtime_1.jsx)(antd_1.List, { dataSource: dataSource, renderItem: (_item, index) => {
                    return ((0, jsx_runtime_1.jsx)(antd_1.List.Item, { actions: [
                            (0, jsx_runtime_1.jsx)(antd_1.Button, { ...options.removeButtonProps, disabled: !removeItems ||
                                    (required && dataSource.length == 1 && index === 0), onClick: (e) => {
                                    e.stopPropagation();
                                    removeItems?.(path, [index])();
                                }, children: options.removeButtonProps?.children ?? "Delete" }, "remove"),
                        ], children: (0, jsx_runtime_1.jsx)("div", { style: { width: "100%" }, children: (0, jsx_runtime_1.jsx)(react_1.JsonFormsDispatch, { enabled: enabled, schema: schema, path: (0, core_1.composePaths)(path, `${index}`), uischema: foundUISchema, renderers: renderers, cells: cells, uischemas: uischemas }) }) }, index));
                }, ...(options.addButtonLocation === "top"
                    ? { header: addButton }
                    : { footer: addButton }) })] }));
}
exports.ObjectArrayControl = ObjectArrayControl;
exports.ObjectArrayRenderer = (0, react_1.withJsonFormsArrayLayoutProps)(react_3.default.memo(ObjectArrayControl));
